import { Roles } from '../../interfaces/src/user.interface'

export const parsedRolesArrayToRolesObject = (rolesArray: string[]): Roles => {
  const rolesObject: Roles = {
    ADVANCED: rolesArray?.includes('ADVANCED') ? 'ADVANCED' : '',
    STARTER: rolesArray?.includes('STARTER') ? 'STARTER' : '',
    BASIC: rolesArray?.includes('BASIC') ? 'BASIC' : '',
    BROKER: rolesArray?.includes('BROKER') ? 'BROKER' : '',
    AGENCY_BROKER: rolesArray?.includes('AGENCY_BROKER') ? 'AGENCY_BROKER' : '',
    AGENCY: rolesArray?.includes('AGENCY') ? 'AGENCY' : '',
    PRIME: rolesArray?.includes('PRIME') ? 'PRIME' : '',
    PRO: rolesArray?.includes('PRO') ? 'PRO' : '',
    DEVELOPER: rolesArray?.includes('DEVELOPER') ? 'DEVELOPER' : '',
    ROLE_ADMIN_DEVELOPER: rolesArray?.includes('ROLE_ADMIN_DEVELOPER')
      ? 'ROLE_ADMIN_DEVELOPER'
      : '',
    DEVELOPER_USER: rolesArray?.includes('DEVELOPER_USER')
      ? 'DEVELOPER_USER'
      : '',
    ASSOCIATION: rolesArray?.includes('ASSOCIATION') ? 'ASSOCIATION' : ''
  }

  const rolesObjectFiltered = Object.fromEntries(
    Object.entries(rolesObject)?.filter(([, value]) => value)
  ) as Roles

  return rolesObjectFiltered
}
